import throttle from 'lodash/throttle'

const DEFAULT_THROTTLE_TIME = 200
const MAX_DEPTH = 21

export default {
  inserted(el, binding) {
    const throttleTime = (binding.value && binding.value.throttleTime) || DEFAULT_THROTTLE_TIME

    const throttleHandler = throttle(() => {
    }, throttleTime)

    const wheelHandler = (event) => {
      let current = event.target
      let depth = 0
      let scrollableFound = false

      // Walk up from the event target until reaching the container or MAX_DEPTH levels
      while (current && current !== el && depth < MAX_DEPTH) {
        if (current.nodeType === 1) {
          const style = window.getComputedStyle(current)
          const isScrollableCss = style.overflowY === 'auto' || style.overflowY === 'scroll'
          // Only consider it scrollable if CSS allows it and its content overflows.
          if (isScrollableCss && current.scrollHeight > current.clientHeight) {
            scrollableFound = true
            break
          }
        }
        current = current.parentElement
        depth++
      }

      // If any scrollable element was found, skip custom scroll handling.
      if (scrollableFound) {
        event.__skipCustomScroll = true
        event.stopPropagation()
        return
      }

      // No scrollable descendant was found, run the custom scroll logic.
      throttleHandler(event)
    }

    el.__wheelHandler__ = wheelHandler
    // Add the event listener in capture phase so it runs early, and passive: false so to preventDefault if needed.
    el.addEventListener('wheel', wheelHandler, { capture: true, passive: false })
  },

  unbind(el) {
    if (el.__wheelHandler__) {
      el.removeEventListener('wheel', el.__wheelHandler__, { capture: true })
      delete el.__wheelHandler__
    }
  },
}
